/**
 * Utility functions for blog URL generation.
 */

/** Relative public URL for a blog post. */
export const blogPostUrl = (slug: string): string => `/blog/${slug}`;

/** Absolute public URL for a blog post (for previews / social sharing). */
export const getPublicBlogUrl = (slug: string): string => {
  if (!slug) return '/blog';
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/blog/${slug}`;
  }
  return `/blog/${slug}`;
};
